import styled from 'styled-components'
import {minWidth} from 'core/theme'

export const Wrapper = styled.div`
  .pl0 {
    padding-left: 0 !important;
  }
  .pr0 {
    padding-right: 0 !important;
  }
  .accordion-menu {
    overflow: hidden;
    li + li {
      margin-top: 0;
    }
  
    &__title {
      ${props => props.theme.typography.latoBold};
      color: ${props => props.theme.colors.smalt};
      text-transform: uppercase;
      font-size: 1.25rem;
    }
  
    &__list {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      padding: 0;
      margin: 0;
    }
  
    &__list-item {
      position: relative;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
  
      &.open {
        border-bottom: 0;
      }
  
      &.open > .accordion-menu__list-control {
        position: relative;
        border-color: transparent;
        &:before {
          left: 16px;
          right: 12px;
          background-color: ${props => props.theme.colors.pepper};
        }
      }
  
  
      &:last-child .accordion-menu__list-control {
        border-bottom: 0;
        padding: 16px;
      }
    }
  
    &__link {
      ${props => props.theme.typography.latoReg};
      padding-top: 11px;
      padding-bottom: 11px;
      padding-left: 16px;
      padding-right: 16px;
      font-size: 1rem;
      color: ${props => props.theme.colors.pepper};
      box-sizing: border-box;
      cursor: pointer;
      line-height: 1.31;
      display: flex;
      padding-left: 32px;
      align-items: flex-start;
      width: 100%;
      max-width: 100%;
      border-top: 1px solid ${props => props.theme.colors.gizmo};
      text-transform: uppercase;
    }
  
    &__link--with-icon {
      .small-icon {
        margin-right: 8px;
        width: 24px;
        height: 24px;
        color: ${props => props.theme.colors.smalt};
      }
    }
  
    &__sub-list {
      padding-left: 16px;
      width: 100%;
      box-sizing: border-box;
      > li ul {
        padding-left: 20px;
      }
    }
  
    &__text-link {
      ${props => props.theme.typography.latoReg};
      font-size: 1rem;
      border-top: 0;
      text-transform: capitalize;
      transition: color .250s ease-out;
    
      &:hover {
        color: ${props => props.theme.colors.smalt};
      }
    }
  
    &__list-control {
      padding-top: 11px;
      padding-bottom: 11px;
      padding-left: 16px;
      padding-right: 16px;
      font-size: 1rem;
      color: ${props => props.theme.colors.pepper};
      box-sizing: border-box;
      cursor: pointer;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 100%;
      text-transform: uppercase;
      transition: color .250s ease-out;
      &:hover {
        color: ${props => props.theme.colors.smalt};
      }
      &:before,
      &:after {
        content: '';
      }
      &:before {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 1px;
        background-color: ${props => props.theme.colors.gizmo};
        transition: left .250s ease-out,
                    right .250s ease-out,
                    background-color .250s ease-out;
      }
      // When the parent accordion has
      // the open class, rotate the chevron
      .accordion.open > &:after {
        transform: rotate(225deg);
      }
    }
  
    &__list-control--small {
      &:after {
        content: "";
        display: inline-block;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid ${props => props.theme.colors.pepper};
        transform: rotate(0);
        border-bottom: 0;
      }
      &:before {
        display: none;
      }
      .accordion.open > &:after {
        transform: rotate(180deg);
      }
    }
  
    &__sub-link {
      ${props => props.theme.typography.latoBold};
      padding-top: 11px;
      padding-bottom: 11px;
      padding-left: 16px;
      padding-right: 16px;
      font-size: rem(16);
      color: ${props => props.theme.colors.pepper};
      box-sizing: border-box;
      cursor: pointer;
      text-transform: capitalize;
      border: 0;
      width: 100%;
      transition: color .250s ease-out;
  
      &:hover {
        color: ${props => props.theme.colors.smalt};
      }
  
      span {
        position: relative;
        top: 2px;
      }
    }
  
    &__link-with-image {
      img {
        max-width: 30px;
        border: 1px solid ${props => props.theme.colors.alto};
        margin-right: 8px;
      }
    }
  
    .icon-drawer {
      margin-right: 5px;
      color: ${props => props.theme.colors.smalt};
    }
  
    .menu-arrow {
      &:after {
        display: block;
        width: 10px;
        height: 10px;
        border-bottom: 2px solid ${props => props.theme.colors.pepper};
        border-right: 2px solid ${props => props.theme.colors.pepper};
        transform: rotate(45deg);
        transition: transform .250s ease-out,
                    border-color .250s ease-out;
      }
  
      &.arrow-right:after {
        transform: rotate(-45deg);
      }
  
      &:hover:after {
        border-color: ${props => props.theme.colors.smalt};
      }
    }
  
    ${minWidth.medium`
      .accordion-menu__sub-link.is-active {
        @include arrow-end(12px, 26px, ${props => props.theme.colors.white});
        color: ${props => props.theme.colors.white};
        background-color: ${props => props.theme.colors.smalt};
  
        .icon-drawer {
          color: ${props => props.theme.colors.white};
        }
      }
    `}
  }
  
  .accordionFooterItem {
    margin-left: 32px;
    margin-top: 15px;
    margin-bottom: 15px;
    font-family: ${props => props.theme.typography.lato};
    font-size: 13px;
    color: rgb(0,122,204);
    display: block;
  }
  
  .accordionFooterItem .icon {
    margin-right: 18px;
    vertical-align: middle;
  }
  
  .accordionFooterItem a {
    font-size: 13px;
    vertical-align: middle;
  }
  
  .utility-menu {
    padding-left: 0;

    li {
      display: block;
    }

    a {
      ${props => props.theme.typography.latoBold};
      padding-top: 11px;
      padding-bottom: 11px;
      padding-left: 16px;
      padding-right: 16px;
      font-size: rem(16);
      color: ${props => props.theme.typography.pepper};
      box-sizing: border-box;
      cursor: pointer;
      color: ${props => props.theme.colors.mercuryBlue};
      display: block;
      display: flex;
      align-items: center;
    }
  }
  
  .site-menu {
    z-index: -1;
    border-bottom: 5px solid ${props => props.theme.colors.smalt};
    width: 100%;
    padding-bottom: 24px;
    position: absolute;
    opacity: 0;
    transform: translateY(-127%);
    transition: transform .250s ease-out;
    top: 100%;
    background-color: ${props => props.theme.colors.white};
    // overflow: scroll;

    &.is-open {
      opacity: 1;
      transform: translateY(0);
    }

    &__header {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      height: 60px;
      padding-bottom: 20px;
      box-sizing: border-box;
      padding-left: 16px;
      padding-right: 32px;
    }

    &__nav-links {
      padding-left: 0;
      margin-top: 0;
      margin-bottom: 0;
    }

    &__nav-link {
      position: relative;
      ${props => props.theme.typography.lato};
      list-style: none;
      border-top: 1px solid ${props => props.theme.colors.gizmo};
      margin-top: 0px;
      padding-top: 16px;
      padding-bottom: 16px;
      padding-left: 32px;

      a {
        font-size: 1rem;
        line-height: 1.18rem;
        color: ${props => props.theme.colors.pepper};
      }

      svg {
        pointer-events: none;
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        height: 11px;
        width: 11px;
        fill: ${props => props.theme.colors.mercuryBlue};
      }
    }

    &__nav-link:last-child {
      padding-bottom: 6px;
    }


    ${minWidth.small`
      & {
        right: 0;
        max-width: 320px;
        box-shadow: -1px 1px 3px 0 transparent;
        transition: transform .250s ease-out,
                    box-shadow .250s ease-out 0s;
        border-left: 1px solid color(base, shady);
        border-right: 1px solid color(base, shady);

        &.is-open {
          border-right: 1px solid color(base, shady);
          box-shadow: -1px 1px 3px 0 rgba(${props => props.theme.colors.black}, 0.1);
          transition: transform .250s ease-out,
                      box-shadow .250s ease-out .100s;
        }
      }
    `}

    ${minWidth.medium`
      top: 55px;
    `}
    
    left: 0;
    padding-bottom: 0;
    border-top: 1px solid ${props => props.theme.colors.alto};
    
    @media (min-width: 768px) {
      left: calc(100% - 320px);
    }
    .without-arrow {
      &::after {
        display: none;
      }
    }
  
    .accordion-menu__sub-list {
      max-height: 0;
      transition: max-height 200ms ease;
      overflow: hidden;
      &.open {
        transition: max-height 600ms ease;
        max-height: 999px;
      }
    }
  
    .accordion-menu__list-control {
      position: relative;
      padding-top: 16px;
      padding-bottom: 16px;
      span {
        position: absolute;
        right: 20px;
        top: 16px;
      }
    }
  }
  
  .special {
    .accordion-menu__list-control {
      font-style: italic;
    }
  }
  
  .accordion-menu__text-link {
    position: relative;
    &.accordion-menu__link-with-image {
      padding-left: 64px;
      > span {
        position: absolute;
        left: 32px;
        top: 8px;
      }
    }
  }
`

export const MenuIcon = styled.a`
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  display: inline-flex;
  height: 61px;
  width: 64px;
  text-align: center;
  align-items: center;
  color: ${props => props.theme.colors.pepper};
  border-left: 1px solid ${props => props.theme.colors.alto};

  span {
    ${props => props.theme.typography.latoBold};
    font-size: 11px;
    text-transform: uppercase;
    line-height: 11px;
    margin-bottom: 5px;
  }
  
  svg.icon {
    margin-left: auto;
    margin-right: auto;
    width: 22px;
    height: 23px;
  }
`
